<div class="chat-saved d-flex flex-column h-100">

  <!-- Header -->
  <div class="chat-saved__header border-bottom px-3 py-2 d-flex align-items-center gap-2 flex-shrink-0">
    <!-- Same avatar tile as every other chat surface (glyph variant). -->
    <span class="chat-avatar-tile flex-shrink-0">
      <i class="ri-bookmark-line" aria-hidden="true"></i>
    </span>
    <div class="flex-grow-1 overflow-hidden">
      <h5 class="m-0 text-truncate">{{ 'chat.saved.title' | translate }}</h5>
      <small class="text-muted">{{ 'chat.saved.subtitle' | translate }}</small>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-light flex-shrink-0"
      (click)="refresh()"
      [matTooltip]="'chat.saved.refresh' | translate"
      [attr.aria-label]="'chat.saved.refresh' | translate"
    >
      <i class="ri-refresh-line"></i>
    </button>
  </div>

  <!-- List -->
  <div class="chat-saved__body flex-grow-1 overflow-auto px-3 py-2">
    @if ((loading$ | async) && rows.length === 0) {
      <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <span class="text-muted">{{ 'chat.saved.loading' | translate }}</span>
      </div>
    } @else if (rows.length === 0) {
      <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-5 px-3 text-center">
        <!-- Soft disc + semantic glyph on the `avatar-title` itself — see the
             note in chat-empty-state.component.html. -->
        <div class="avatar-sm">
          <i class="ri-bookmark-line avatar-title rounded-circle bg-soft-warning text-warning font-18"></i>
        </div>
        <h5 class="mb-0">{{ 'chat.saved.empty' | translate }}</h5>
        <span class="text-muted">{{ 'chat.saved.emptyHint' | translate }}</span>
      </div>
    } @else {
      @for (row of rows; track trackRow($index, row)) {
        <div class="chat-saved__row card mb-2">
          <div class="card-body p-2">
            <div class="d-flex align-items-center gap-2 mb-1">
              <i class="text-muted flex-shrink-0" [ngClass]="row.channelIcon"></i>
              <small class="text-muted text-truncate flex-grow-1">{{ row.channelName }}</small>
              <small class="text-muted flex-shrink-0">{{ row.timeLabel }}</small>
            </div>

            <div class="d-flex gap-2">
              <span
                class="chat-avatar-tile flex-shrink-0"
                [matTooltip]="authorTooltip(row)"
              >
                @if (row.authorImage) {
                  <img [src]="row.authorImage" [alt]="row.authorName">
                } @else {
                  {{ row.authorInitial }}
                }
                <span
                  class="chat-avatar-tile__presence rounded-circle"
                  [ngClass]="dotFor(row)"
                  aria-hidden="true"
                ></span>
              </span>
              <div class="flex-grow-1 overflow-hidden">
                <span class="fw-semibold d-block chat-name">{{ row.authorName }}</span>
                @if (row.isMedia) {
                  <span class="d-inline-flex align-items-center gap-1">
                    <i class="text-muted" [ngClass]="row.fileIcon"></i>
                    <small class="text-truncate">{{ row.fileName }}</small>
                    @if (row.fileSizeLabel) {
                      <small class="text-muted">{{ row.fileSizeLabel }}</small>
                    }
                  </span>
                } @else {
                  <p class="m-0 chat-saved__content" [innerHTML]="row.content | chatMarkdown"></p>
                }
              </div>
            </div>

            <div class="d-flex justify-content-end gap-1 mt-1">
              <button type="button" class="btn btn-sm btn-soft-primary" (click)="open(row)">
                <i class="ri-corner-up-right-line me-1"></i>{{ 'chat.saved.goToConversation' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-light" (click)="unsave(row)">
                <i class="ri-bookmark-2-line me-1"></i>{{ 'chat.saved.remove' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
